import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { HttpHeadersService } from '../shared-service/http-headers.service';
import { RootScopeService } from '../shared-service/root-scope.service';
import { RootScopeDeclare } from '../rootscope-declare';
import { RootScopeData } from '../rootscope-data';

@Injectable({
  providedIn: 'root'
})
export class GetCountryTimezoneService {

  rootScopeData: RootScopeDeclare;

  constructor(private httpClient: HttpClient, private rootScopeService: RootScopeService, private httpHeaderService: HttpHeadersService) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  getCountryTimezoneList(): Observable<any> {
   const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
   return this.httpClient.get(environment.servicePath + '/facility_maintenance/get_timezone', { headers});
  }
}
